import { Company, ConfigClient } from "@/data/web-api-client";
import axios from "axios";
import AxiosClient from "@/data/AxiosClient";
import * as msal from '@azure/msal-browser';
import { AuthConfig, SecurityConfig, LayoutConfig, MailConfig, AzureADOptions, CompanyConfig } from "../installationConfig";
import { result } from "lodash";

export default class installationConfigService {
  // Used for anonymous endpoints (before authentication)
  private configClient: ConfigClient = new ConfigClient(undefined, axios);
  // Used for authenticated endpoints (after authentication)
  private authenticatedConfigClient: ConfigClient = new ConfigClient(undefined, AxiosClient);

  public async init() {
    var promises = [];

    promises.push(this.initCompanyConfig());
    promises.push(this.initLayoutConfig());
    promises.push(this.initMailConfig());

    return Promise.all(promises);
  }

  private async initCompanyConfig(){
    return this.authenticatedConfigClient.getCompanyConfig().then((result) => {
      CompanyConfig.companyName = result.companyName;
      CompanyConfig.firstName = result.firstName;
      CompanyConfig.lastName = result.lastName;
      CompanyConfig.street = result.street;
      CompanyConfig.streetNumber = result.streetNumber;
      CompanyConfig.city = result.city;
      CompanyConfig.postalCode = result.postalCode;
      CompanyConfig.country = result.country;
      CompanyConfig.email = result.email;
      CompanyConfig.invoiceAccountantEmail = result.invoiceAccountantEmail;
      CompanyConfig.creditNoteAccountantEmail = result.creditNoteAccountantEmail;
      CompanyConfig.timeZone = result.timeZone;
      CompanyConfig.vatNumber = result.vatNumber;
      CompanyConfig.invoiceDocumentNumberFormat = result.invoiceDocumentNumberFormat;
    });
  }

  public async initAuthenticationConfig() {
    return this.configClient.getAuthenticationConfig().then((result) => {
      const msalConfig = {
        auth: {
          clientId: result.clientId!,
          authority: result.site,
          redirectUri: window.location.origin + '/',
          navigateToLoginRequestUrl: false
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false,
        },
      };

      AuthConfig.msalInstance = new msal.PublicClientApplication(msalConfig);
    });
  }

  public async initSecurityConfig() {
    return this.configClient.getSecurityConfig().then((result) => {
      SecurityConfig.administrationGroup = result.administrationGroup;
      SecurityConfig.calculatorGroup = result.calculatorGroup;
      SecurityConfig.hrGroup = result.hrGroup;
      SecurityConfig.administratorGroup = result.administratorGroup;
      SecurityConfig.qualityGuardGroup = result.qualityGuardGroup;
      SecurityConfig.qualityGuardOneSkinGroup = result.qualityGuardOneSkinGroup;
      SecurityConfig.projectCoordinatorGroup = result.projectCoordinatorGroup;
      SecurityConfig.userGroup = result.userGroup;
      SecurityConfig.invoicingRead = result.invoicingRead;
      SecurityConfig.articleReadWrite = result.articleReadWrite;
      SecurityConfig.quotationRead = result.quotationRead;
      SecurityConfig.machineryRead = result.machineryRead;
      SecurityConfig.machineryReadWrite = result.machineryReadWrite;
      SecurityConfig.purchaseRead = result.purchaseRead;
      SecurityConfig.purchaseOrderRead = result.purchaseOrderRead;
      SecurityConfig.taskAdmin = result.taskAdmin;
    });
  }

  public async initAzureADOptions() {
    return this.configClient.getAzureADOptions().then((result) => {
      AzureADOptions.clientId = result.clientId;
    });
  }

  private async initLayoutConfig() {
    return this.authenticatedConfigClient.getLayoutConfig().then((result) => {
      LayoutConfig.faviconPrefix = result.faviconPrefix;
      LayoutConfig.headTitle = result.headTitle;
      LayoutConfig.footerText = result.footerText;
      LayoutConfig.navbarLogoUrl = result.navbarLogoUrl;
      LayoutConfig.navbarCompanyName = result.navbarCompanyName;
    });
  }

  private async initMailConfig() {
    return this.authenticatedConfigClient.getMailConfig().then((result) => {
      MailConfig.infoMailAddress = result.infoMailAddress;
      MailConfig.accountingMailAddress = result.accountingMailAddress;
      MailConfig.executionMailAddress = result.executionMailAddress;
      MailConfig.invoicingMailAddress = result.invoicingMailAddress;
      MailConfig.calculationMailAddress = result.calculationMailAddress;
      MailConfig.fromName = result.fromName;
      MailConfig.erpReportingName = result.erpReportingName;
    });
  }
}